module.exports = __webpack_public_path__ + "static/media/search-icon-brand-refresh.eba3179a.svg";